export function convertEnumToArray<T>(enumParam: T): Array<[string, string]> {
  return Object.entries(enumParam).map((option) => option)
}

interface AddOrReplaceBy<T> {
  array: Array<T>
  addIfItemNotFound: (elem: T) => boolean
  item: T
}
export function addOrReplaceBy<T>({
  array,
  addIfItemNotFound,
  item,
}: AddOrReplaceBy<T>): T[] {
  const index = array.findIndex(addIfItemNotFound)
  return index === -1
    ? [...array, item]
    : [...array.slice(0, index), item, ...array.slice(index + 1)]
}

export function removeIndex<T>({
  array,
  index,
}: {
  array: Array<T>
  index: number
}): T[] {
  return [...array.slice(0, index), ...array.slice(index + 1)]
}

export function chunkArray<T>(
  myArray: Array<T>,
  chunkSize: number
): Array<Array<T>> {
  let results = []

  if (chunkSize === 0 || chunkSize > myArray.length) {
    return [myArray]
  }

  while (myArray.length) {
    results.push(myArray.splice(0, chunkSize))
  }
  return results
}

type THelper<T, U> = T extends string
  ? { [P in T]: P extends U ? P : never }[T] extends { [P in T]: unknown }
  ? U
  : never
  : U

export function includes<
  T,
  U extends THelper<T, U> extends never ? unknown : never
>(arr: readonly T[], searchElement: U, fromIndex?: number): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (arr as any).includes(searchElement, fromIndex)
}

export const areArraysEquals = <T>(arr1: T[], arr2: T[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  const serialize = (obj: T) => JSON.stringify(obj);

  const sorted1 = arr1.map(serialize).sort();
  const sorted2 = arr2.map(serialize).sort();

  return sorted1.every((val, index) => val === sorted2[index]);
};
